"use client"

import type { FormEvent } from "react"
import type { SupportedLocales } from "#environment/i18nConfig"

import React, { useState } from "react"
import toast from "react-hot-toast"

import { contactService } from "#modules/contact/contact.service"
import { useTranslation } from "#modules/localization/translations.client"
import { Link } from "#utils/localization/clientUtils"
import { TransBasicFormat } from "#utils/localization/transBasicFormat"

// TODO use generic component for this form
export function FooterContactForm({ locale }: { locale: SupportedLocales }) {
  const { t, i18n } = useTranslation("common", "cp/footer", "glossar")

  const [email, setEmail] = useState("")

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    toast.loading(t("loading.loading"))

    try {
      await contactService.sendContactForm({ email, artist: false })

      toast.dismiss()
      toast.success(t("cp/footer:emailSuccess"))
      setEmail("")
    } catch (e) {
      toast.dismiss()
      toast.error(t("loading.errorVerifyInput"))
    }
  }

  return (
    <section className={"mt-10 flex w-full gap-6 xl:mt-0"}>
      <div className={"h-auto w-1 bg-gold-100 md:hidden"} />
      <div className={"flex w-full flex-col"}>
        <div className={"flex w-full items-end justify-between"}>
          <p className={"text-nm font-bold"}>{t("glossar:generic.newsletter")}</p>
          <div className={"h-1 w-20 bg-white"}></div>
        </div>
        <p className={"mt-5 text-[10px]"}>{t("cp/footer:newsletterDescription")}</p>
        <form onSubmit={e => handleSubmit(e)} className={"relative mt-2 flex w-full items-center justify-end"}>
          <input
            value={email}
            placeholder={"E-Mail-Adresse"}
            onChange={e => setEmail(e.target.value)}
            className={"absolute w-full bg-peach-100 px-5 py-4 text-[12px] text-black"}
          />
          <input type="submit" value={"Anmelden"} className={"relative right-2 h-14 w-24 cursor-pointer bg-gold-100 text-[12px] font-bold text-black"} />
        </form>
        <p className={"mt-4 text-[10px]"}>
          <TransBasicFormat
            i18n={i18n}
            i18nKey={"cp/footer:newsletterLegalNotice"}
            t={t}
            components={{
              dataPrivacy: (
                <Link href={"/data-privacy"} locale={locale} className={"font-medium text-gray-50"}>
                  {t("glossar:legal.dataPrivacy")}
                </Link>
              ),
            }}
          />
        </p>
      </div>
    </section>
  )
}
